import React from "react";
import styled from "styled-components";
import { LinkContainer } from "components/common/router";
import { NavDropdown } from "components/bootstrap";
import { Icon } from "components/common";
import Routes from "routing/Routes";
import useCurrentUser from "hooks/useCurrentUser";
import Menu from "components/bootstrap/Menu";
import useLogout from "hooks/useLogout";
import NavIcon from "components/navigation/NavIcon";
import ThemeModeToggle from "./ThemeModeToggle";
const FullName = styled.span`
  text-transform: uppercase;
  font-weight: 700;
`;
const UserMenu = () => {
  const { fullName, readOnly, id: userId } = useCurrentUser();
  const route = readOnly ? Routes.SYSTEM.USERS.show(userId) : Routes.SYSTEM.USERS.edit(userId);
  const label = readOnly ? "Show profile" : "Edit profile";
  const onLogoutClicked = useLogout();
  return /* @__PURE__ */ React.createElement(NavDropdown, { title: /* @__PURE__ */ React.createElement(NavIcon, { type: "user_menu" }), hoverTitle: `User Menu for ${fullName}`, noCaret: true }, /* @__PURE__ */ React.createElement(Menu.Label, null, /* @__PURE__ */ React.createElement(FullName, null, fullName)), /* @__PURE__ */ React.createElement(Menu.Divider, null), /* @__PURE__ */ React.createElement(Menu.Label, null, /* @__PURE__ */ React.createElement(ThemeModeToggle, null)), /* @__PURE__ */ React.createElement(Menu.Divider, null), /* @__PURE__ */ React.createElement(LinkContainer, { to: route }, /* @__PURE__ */ React.createElement(Menu.Item, null, label)), /* @__PURE__ */ React.createElement(Menu.Item, { onClick: onLogoutClicked, leftSection: /* @__PURE__ */ React.createElement(Icon, { name: "logout" }) }, "Log out"));
};
export default UserMenu;
